import { load } from '@azure/app-configuration-provider';

import { PimSfccConfigurationSettings } from 'common/types/pimSfccConfigurationTypes';
import getConfig from 'temp/config';

export const loadPimSfccMappings = async (): Promise<Record<string, unknown>> => {
  try {
    const appConfigurationKey = 'pim:sfcc:attributes-mapping';
    const { configurationManagementEndpoint, configurationManagementLabel } = getConfig();

    const settings = await load(configurationManagementEndpoint, {
      selectors: [
        {
          keyFilter: `${appConfigurationKey}*`,
          labelFilter: configurationManagementLabel,
        },
      ],
    });

    const rawConfigObject = settings.constructConfigurationObject();
    const configSettings = rawConfigObject[appConfigurationKey] as PimSfccConfigurationSettings;
    return configSettings?.pimSfccMappings || {};
  } catch (error) {
    console.warn('Failed to load Azure App Configuration:', error);
    return {};
  }
};
